import { FC, useEffect } from 'react';

import { getSelectedNamedPrograms, getSelectedPrograms } from '@features/programsSlice';
import useTranslateProgram from '@hooks/useTranslateProgram';
import NewOrderBase from '@routes/NewOrder/NewOrderBase';
import { ROUTES } from '@routes/constants';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const NewOrderPrograms: FC = () => {
  const selectedPrograms = useSelector(getSelectedPrograms);
  const namedSelected = useSelector(getSelectedNamedPrograms);
  const { mutateAsync, isLoading, error, isError, reset } = useTranslateProgram();
  const navigate = useNavigate();

  useEffect(() => {
    if (!selectedPrograms || !selectedPrograms.length) navigate(ROUTES.PROGRAMS);
  }, [selectedPrograms, navigate]);

  return (
    <NewOrderBase
      type={'programs'}
      mutationError={error}
      mutationIsError={isError}
      mutationIsLoading={isLoading}
      mutationReset={reset}
      selected={selectedPrograms}
      onSend={(data) => mutateAsync({ ...data, ids: selectedPrograms })}
      namedSelected={namedSelected}
    />
  );
};

export default NewOrderPrograms;
